import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Loader, Grid, Card, Icon, Message,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import util from 'utils/utils';

const types = {
  slack: {
    icon: 'slack',
    name: 'Slack',
  },
};

class OAuthConnection extends Component {
  state = { loading: false, errorMessage: null, type: null };

  componentDidMount() {
    const connectionType = this.props.match.params.type;
    if (!types[connectionType]) {
      this.setState({ errorMessage: 'Simply Do does not currently support connections with this service.' });
    } else {
      const type = types[connectionType];
      this.setState({ type, loading: true });
    }
  }

  render() {
    const { loading, errorMessage, type } = this.state;
    return (
      <Grid stackable centered style={{ marginTop: 40 }}>
        <Grid.Column computer={6} tablet={10}>
          <Card fluid raised color='yellow'>
            {type
              && <Card.Content textAlign='center' style={{ paddingTop: 20 }}>
                <Icon style={{ fontSize: 40 }} name={type.icon} />
                <h3 style={{ marginTop: 10 }}>Adding {type.name} to your {util.appName()} account...</h3>
              </Card.Content>
            }
            {loading
              ? <Card.Content>
                <Loader active inline='centered' />
              </Card.Content> : null}
            {!loading && errorMessage
              ? <Card.Content>
                  <Message error>{errorMessage}</Message>
                </Card.Content>
              : <React.Fragment>
                  <Card.Content>
                    <h2>Done</h2>
                  </Card.Content>
                </React.Fragment>
              }
            }
          </Card>
        </Grid.Column>
      </Grid>
    );
  }
}

export default withRouter(withTranslation()(OAuthConnection));
